import * as React from "react";
import { SVGProps, memo } from "react";

const SvgList = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={21} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.833 8.083v-1.75H17.5v1.75H5.833Zm0 3.292v-1.75H17.5v1.75H5.833Zm0 3.292v-1.75H17.5v1.75H5.833ZM3.354 8.062a.823.823 0 0 1-.604-.25.823.823 0 0 1-.25-.604c0-.236.083-.437.25-.604a.823.823 0 0 1 .604-.25c.236 0 .437.083.604.25.167.167.25.368.25.604a.823.823 0 0 1-.25.604.823.823 0 0 1-.604.25Zm0 3.292a.823.823 0 0 1-.604-.25.823.823 0 0 1-.25-.604c0-.236.083-.437.25-.604a.823.823 0 0 1 .604-.25c.236 0 .437.083.604.25.167.167.25.368.25.604a.823.823 0 0 1-.25.604.823.823 0 0 1-.604.25Zm0 3.292a.823.823 0 0 1-.604-.25.823.823 0 0 1-.25-.604c0-.236.083-.437.25-.604a.823.823 0 0 1 .604-.25c.236 0 .437.083.604.25.167.167.25.368.25.604a.823.823 0 0 1-.25.604.823.823 0 0 1-.604.25Z"
      fill="#fff"
    />
  </svg>
);

const Memo = memo(SvgList);

export default Memo;
